module.exports = __webpack_public_path__ + "img/paint-strip-black-down.5ef9947.png";